import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { Box } from '@mui/material';
import { useResourceContext } from 'react-admin';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import { RateFieldCheckbox } from './RateFieldCheckbox';

type Props = { source: string };

export const ChargeRateCentsInput = ({ source }: Props) => {
  const resource = useResourceContext();
  const { isControlled } = useRateControllerContext();
  const isLocationLevel =
    resource === 'LocationPositionRateSetting' || resource === 'AgencyLocationPositionRateSetting';
  const label = isLocationLevel ? 'Location Rate' : '8hr Charge Rate';

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <MoneyInput
        source={`${source}.charge_rate_cents`}
        label={label}
        disabled={!isControlled('chargeRate')}
        sx={{ flex: 1 }}
      />
      <RateFieldCheckbox code="chargeRate" label="Admin controls Location Rate" />
    </Box>
  );
};
